<template>
  <div class="pushNotificationMessagesDashboard " :class="'pushNotificationMessagesDashboard --' + dashboardType">
    <div class="bookingDashboard bookingDashboard--list">
      <div class="bookingDashboard__header bookingDashboard__header--provider">
        <div class="bookingDashboard__title">Push notification messages</div>
        <router-link class="buttonCreate" to="new-push-notification-message">Create</router-link>
      </div>
      <div class="bookingDashboard__table">
        <div class="bookingDashboard__table-header">
          <div class="bookingDashboard__table-cell">Created on</div>
          <div class="bookingDashboard__table-cell">Popup Title</div>
          <div class="bookingDashboard__table-cell">Type</div>
        </div>
        <div class="bookingDashboard__table-body">
          <vue-scroll :ops="ops">
            <div
              class="bookingDashboard__table-row"
              v-for="item of pushNotificationMessages"
              :key="item.id"
            >
              <div class="bookingDashboard__table-cell aircraftNumber">{{item.createdOn}}</div>
              <div class="bookingDashboard__table-cell aircraftModel">{{item.popupTitle}}</div>
              <div class="bookingDashboard__table-cell aircraftType">
                {{item.type}}
                <router-link class="bookingDashboard__table-detail" :to="'push-notification-message/'+ item.id">click for details</router-link>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Tabs } from '@/js/plugins/tabs'
  import './PushNotificationMessages.styl'

  export default {
    props: ['dashboardType'],
    name: 'PushNotificationMessages',
    data: () => ({
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
    }),
    computed: {
      pushNotificationMessages () {
        return this.$store.state.pushNotificationMessages.list
      },
    },
    async created () {
      await this.$store.dispatch('getPushNotificationMessages')
    },
  }
</script>
